export const partTimePct = (tipo, ore) => {
    if (!ore || !/part/i.test(tipo || "")) return null;
    const pct = (Number(ore) / 40) * 100;
    if (!isFinite(pct) || pct <= 0) return null;
    return `${pct.toLocaleString("it-IT", { maximumFractionDigits: 2 })}%`;
};
